import React, { useState } from 'react';
import { useGameStore, useGameActions } from '../hooks/useGameStore';

export const HUD: React.FC = () => {
  const state = useGameStore();
  const actions = useGameActions();
  const [showSoundSettings, setShowSoundSettings] = useState(false);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <>
      {/* Top right info */}
      <div style={{
        position: 'fixed',
        top: '0.8rem',
        right: '0.8rem',
        zIndex: 50,
        display: 'flex',
        gap: '0.8rem',
        alignItems: 'center',
      }}>
        <span style={{
          color: '#555',
          fontSize: '0.95rem',
          fontFamily: 'monospace',
        }}>
          {formatTime(state.playtime)}
        </span>

        <span style={{
          color: '#555',
          fontSize: '0.9rem',
          fontFamily: '"Noto Serif JP", serif',
        }}>
          探索 {state.explorationRate}%
        </span>

        <button
          onClick={() => actions.toggleMenu()}
          style={{
            background: 'none',
            border: '1px solid #444',
            color: '#777',
            padding: '0.3rem 0.6rem',
            cursor: 'pointer',
            fontSize: '0.95rem',
            borderRadius: '2px',
            fontFamily: '"Noto Serif JP", serif',
          }}
        >
          MENU
        </button>
      </div>

      {/* Menu overlay */}
      {state.isMenuOpen && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0, 0, 0, 0.9)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          zIndex: 200,
          fontFamily: '"Noto Serif JP", serif',
        }}>
          <h2 style={{
            color: '#888',
            letterSpacing: '0.3em',
            marginBottom: '2rem',
            fontSize: '1.5rem',
          }}>
            MENU
          </h2>

          <button onClick={() => { actions.saveGame(); actions.toggleMenu(); }} style={menuBtnStyle}>
            セーブ
          </button>
          <button onClick={() => setShowSoundSettings(!showSoundSettings)} style={menuBtnStyle}>
            サウンド
          </button>

          {showSoundSettings && (
            <div style={{
              width: '280px',
              padding: '1rem 1.5rem',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid #333',
              borderRadius: '6px',
            }}>
              <div style={{ marginBottom: '1rem' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: '#aaa',
                  fontSize: '1rem',
                  marginBottom: '0.4rem',
                }}>
                  <span>BGM</span>
                  <span>{Math.round(state.bgmVolume * 100)}%</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={Math.round(state.bgmVolume * 100)}
                  onChange={e => actions.setBgmVolume(Number(e.target.value) / 100)}
                  style={sliderStyle}
                />
              </div>
              <div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: '#aaa',
                  fontSize: '1rem',
                  marginBottom: '0.4rem',
                }}>
                  <span>効果音</span>
                  <span>{Math.round(state.sfxVolume * 100)}%</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={Math.round(state.sfxVolume * 100)}
                  onChange={e => actions.setSfxVolume(Number(e.target.value) / 100)}
                  style={sliderStyle}
                />
              </div>
            </div>
          )}

          <button onClick={() => { setShowSoundSettings(false); actions.toggleMenu(); }} style={menuBtnStyle}>
            閉じる
          </button>
          <button
            onClick={() => {
              if (window.confirm('タイトルに戻りますか？（セーブしていないデータは失われます）')) {
                setShowSoundSettings(false);
                actions.resetGame();
              }
            }}
            style={{ ...menuBtnStyle, borderColor: '#533', color: '#a55' }}
          >
            タイトルに戻る
          </button>

          <div style={{
            marginTop: '2rem',
            color: '#444',
            fontSize: '0.95rem',
            textAlign: 'center',
            lineHeight: 2,
          }}>
            <p>探索率: {state.explorationRate}%</p>
            <p>謎解き: {state.solvedPuzzles.length}/12</p>
            <p>日記: {state.diaryFragmentsFound}/5</p>
            <p>プレイ時間: {formatTime(state.playtime)}</p>
          </div>
        </div>
      )}

      {/* Message log (latest) */}
      {state.messageLog.length > 0 && (
        <div style={{
          position: 'fixed',
          bottom: '3.5rem',
          right: '1rem',
          zIndex: 40,
          maxWidth: '300px',
        }}>
          <p style={{
            color: '#888',
            fontSize: '0.95rem',
            fontFamily: '"Noto Serif JP", serif',
            background: 'rgba(0,0,0,0.7)',
            padding: '0.5rem 0.8rem',
            borderRadius: '4px',
            lineHeight: 1.5,
            whiteSpace: 'pre-line',
          }}>
            {state.messageLog[state.messageLog.length - 1]}
          </p>
        </div>
      )}
    </>
  );
};

const menuBtnStyle: React.CSSProperties = {
  padding: '0.8rem 3rem',
  fontSize: '1.1rem',
  background: 'transparent',
  border: '1px solid #555',
  color: '#ccc',
  cursor: 'pointer',
  fontFamily: '"Noto Serif JP", serif',
  letterSpacing: '0.3em',
  borderRadius: '4px',
  minWidth: '200px',
  transition: 'all 0.2s',
};

const sliderStyle: React.CSSProperties = {
  width: '100%',
  height: '4px',
  cursor: 'pointer',
  accentColor: '#c8a87c',
};
